import { render, staticRenderFns } from "./create-form.vue?vue&type=template&id=f770ad1a"
import script from "./create-form.vue?vue&type=script&lang=js"
export * from "./create-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports